import { createAction } from '@reduxjs/toolkit';

import { SET_USER, type User } from './types';

export const setUser = createAction<User | null, typeof SET_USER>(SET_USER);
